@if (deviationType$ | async; as deviationType) {
  <ng-container [formGroup]="trafficDeviationAffectedGroup">
    <fieldset>
      <span class="title">
        {{ 'Time span' | translate }}
      <p class="title-explanation">{{ 'Validity period for the traffic controller action' | translate }}</p>
      </span>
    </fieldset>
    <ng-container>
      <fieldset>
        <label class="label-above" for="startDate">
          {{ 'Start time' | translate }}
        </label>
        <div class="form-group flex-60">
          <app-form-date
            [control]="trafficDeviationAffectedGroup.controls.startDate"
            [readonly]="readonlyStartDate"
            [id]="'startDate'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-date>
        </div>
        <div class="form-group flex-40">
          <app-form-time
            [control]="trafficDeviationAffectedGroup.controls.startTime"
            [readonly]="readonlyStartDate"
            [id]="'startTime'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-time>
        </div>
      </fieldset>
      <fieldset>
        <label class="label-above" for="endDate">
          {{ 'End time' | translate }}
        </label>
        <div class="form-group flex-60">
          <app-form-date
            [control]="trafficDeviationAffectedGroup.controls.endDate"
            [readonly]="readonlyEndDate"
            [id]="'endDate'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-date>
        </div>
        <div class="form-group flex-40">
          <app-form-time
            [control]="trafficDeviationAffectedGroup.controls.endTime"
            [readonly]="readonlyEndDate"
            [id]="'endTime'"
            [showValidation]="true"
            [preValidate]="true">
          </app-form-time>
        </div>
      </fieldset>
    </ng-container>
    <fieldset>
      <span class="title">
        {{ 'Affected' | translate }}
        <p class="title-explanation">{{ 'Select which traffic is affected by the deviation' | translate }}</p>
      </span>
    </fieldset>

    @if (deviationType.connectionCancellation === false) {
      <app-search-stop></app-search-stop>
    }
  </ng-container>
}